<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="primary--text pb-2">Your Password</h2>
    </v-flex>
    <v-flex xs12 md6 id="usereditpassword-main">
      <p class="pb-1">To change the password please enter a new password and re-enter to confirm it.</p>
      <v-form>
        <v-text-field
          :append-icon="show1 ? 'visibility_off' : 'visibility'"
          @click:append="show1 = !show1"
          :type="show1 ? 'text' : 'password'"
          :rules="[rules.min]"
          class="usereditpassword-pass-text pb-3"
          label="Password"
          v-model="password"
          :placeholder="this.passwordph"
          @change="userUpdated()"
          box
        ></v-text-field>

        <v-text-field
          :append-icon="show2 ? 'visibility_off' : 'visibility'"
          @click:append="show2 = !show2"
          :type="show2 ? 'text' : 'password'"
          aria-label="usereditpassword-pass2-text"
          label="Confirm Password"
          v-model="passConfirm"
          :placeholder="this.passwordph"
          @change="userUpdated()"
          class="pb-3"
          :error-messages="passwordMatchError()"
          box
        ></v-text-field>
      </v-form>
      <p class="pb-1">
        Note: Your new password must be at least 6 characters long and should contain a mixture of uppercase,
        lowercase, numbers and symbols.
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {
      password: "",
      passConfirm: "",
      passwordph: "e.g. 5UpeR$Ecr3+",
      show1: false,
      show2: false,
      rules: {
        min: v => v.length >= 6 || "Min 6 characters"
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.currentlySelected.user
    })
  },
  methods: {
    passwordMatchError() {
      return this.password === this.passConfirm
        ? ""
        : "Your passwords don't match"
    },
    userUpdated() {
      if (this.password === this.passConfirm && this.password.length >= 6) {
        this.$store.dispatch("updatePassword", {
          password: this.password,
          confirmation: this.passConfirm
        })
        this.$emit("userUpdate")
        this.$emit("passUpdate")
      }
    }
  }
}
</script>
